export async function middleware() {
  // Middleware for PDF handling can be added here if needed
}

export const config = {
  matcher: ['/eBook/:path*'],
};
